import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { StepNavigation } from "../../utilities/StepperComponents";

const PaymentDetails = ({ error, disableButton, data, handleChange, nextStep }) => {
	const next = (e) => {
		e.preventDefault();
		nextStep();
	};

	return (
		<div className="modern-form-container">
			<Form>
				<div className="modern-form-group">
					<label className="modern-label">Teller Name / Payer Name</label>
					<input
						className={`modern-form-control ${error?.tellerName ? 'is-invalid' : ''}`}
						placeholder="John Doe"
						type="text"
						name="tellerName"
						defaultValue={data?.tellerName}
						required
						onChange={handleChange}
					/>
					{error?.tellerName && <div className="invalid-feedback d-block">{error.tellerName}</div>}
				</div>

				<div className="modern-form-group">
					<label className="modern-label">Transaction ID / Ref Number</label>
					<input
						className={`modern-form-control ${error?.tellerRefNum ? 'is-invalid' : ''}`}
						placeholder="TRX-123456"
						type="text"
						name="tellerRefNum"
						defaultValue={data?.tellerRefNum}
						required
						onChange={handleChange}
					/>
					{error?.tellerRefNum && <div className="invalid-feedback d-block">{error.tellerRefNum}</div>}
				</div>

				<Row>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Amount Paid (N)</label>
							<input
								className={`modern-form-control ${error?.amountPaid ? 'is-invalid' : ''}`}
								type="text"
								name="amountPaid"
								placeholder="2000"
								defaultValue={data?.amountPaid}
								required
								onChange={handleChange}
							/>
							{error?.amountPaid && <div className="invalid-feedback d-block">{error.amountPaid}</div>}
						</div>
					</Col>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Date of Payment</label>
							<input
								className={`modern-form-control ${error?.paymentDate ? 'is-invalid' : ''}`}
								type="date"
								name="paymentDate"
								defaultValue={data?.paymentDate}
								required
								onChange={handleChange}
							/>
							{error?.paymentDate && <div className="invalid-feedback d-block">{error.paymentDate}</div>}
						</div>
					</Col>
				</Row>

				<div className="modern-form-group">
					<label className="modern-label">Name of Bank Paid From</label>
					<input
						className={`modern-form-control ${error?.bankName ? 'is-invalid' : ''}`}
						placeholder="e.g. Keystone Bank"
						type="text"
						name="bankName"
						defaultValue={data?.bankName}
						required
						onChange={handleChange}
					/>
					{error?.bankName && <div className="invalid-feedback d-block">{error.bankName}</div>}
				</div>

				<StepNavigation
					currentStep={1}
					totalSteps={4}
					onNext={next}
					disableNext={disableButton}
				/>
			</Form>
		</div>
	);
};

export default PaymentDetails;
